import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  row: {
    flexDirection: "row",
    outline: "none",
  },
});

export default useStyles;
